/**
 * <product-tabs> — toggles category tabs in the "Find What You Need" section.
 * No imports; loaded as a plain module.
 */
class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-panel]'));
    this.tabs.forEach((tab) => tab.addEventListener('click', this.#onClick));
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => tab.removeEventListener('click', this.#onClick));
  }

  #onClick = (event) => {
    const index = event.currentTarget.getAttribute('data-tab');
    this.#activate(index);
  };

  #activate(index) {
    this.tabs.forEach((tab) => {
      const active = tab.getAttribute('data-tab') === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this.panels.forEach((panel) => {
      const active = panel.getAttribute('data-panel') === index;
      panel.classList.toggle('is-active', active);
      panel.toggleAttribute('hidden', !active);
    });
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}
